/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "_host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
        ],
        name: "connectPoolTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "transferabilityForUnitsOwner",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "distributionFromAnyAddress",
                        type: "bool",
                    },
                ],
                internalType: "struct PoolConfig",
                name: "config",
                type: "tuple",
            },
        ],
        name: "createPoolTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
        ],
        name: "disconnectPoolTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "int96",
                name: "requestedFlowRate",
                type: "int96",
            },
        ],
        name: "distributeFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "requestedAmount",
                type: "uint256",
            },
        ],
        name: "distributeToPoolTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "requestedAmount",
                type: "uint256",
            },
        ],
        name: "estimateDistributionActualAmountTest",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
            {
                internalType: "int96",
                name: "requestedFlowRate",
                type: "int96",
            },
        ],
        name: "estimateFlowDistributionActualFlowRateTest",
        outputs: [
            {
                internalType: "int96",
                name: "actualFlowRate",
                type: "int96",
            },
            {
                internalType: "int96",
                name: "totalDistributionFlowRate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
        ],
        name: "getFlowDistributionFlowRateTest",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "member",
                type: "address",
            },
        ],
        name: "isMemberConnectedTest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x60a06040523480156200001157600080fd5b5060405162002083380380620020838339810160408190526200003491620000b5565b6001600160a01b03811660808190526040805163bd1c448b60e01b81526435000000016004820181905260248201929092526000604482015290919063bd1c448b90606401600060405180830381600087803b1580156200009457600080fd5b505af1158015620000a9573d6000803e3d6000fd5b505050505050620000e7565b600060208284031215620000c857600080fd5b81516001600160a01b0381168114620000e057600080fd5b9392505050565b608051611f806200010360003960006105430152611f806000f3fe608060405234801561001057600080fd5b50600436106100f55760003560e01c806364548ce311610097578063af196af611610066578063af196af614610214578063c157ebbb14610227578063d86ed3e5146100fa578063ffa85a6f1461025457600080fd5b806364548ce3146101a7578063884d1f40146101ba5780638c744b17146101cd578063a6db62d8146101f357600080fd5b80634aa23a64116100d35780634aa23a641461014b57806353c11f991461015e57806359088b76146101715780635f9e7d771461019457600080fd5b8063230dbd29146100fa5780632496f4b41461012357806330d9c91514610138575b600080fd5b61010d61010836600461161d565b610267565b60405161011a9190611737565b60405180910390f35b61013661013136600461174a565b6102b7565b005b61010d61014636600461179b565b6102d3565b610136610159366004611839565b61033b565b61010d61016c36600461161d565b610353565b61018461017f366004611872565b6103b8565b604051901515815260200161011a565b61010d6101a236600461179b565b6103d6565b6101366101b5366004611839565b61043d565b61010d6101c836600461179b565b610450565b6101e06101db366004611872565b6104b3565b604051600b9190910b815260200161011a565b61020661020136600461174a565b6104c9565b60405190815260200161011a565b6101366102223660046118cc565b6104e9565b61023a6102353660046118cc565b6104fe565b60408051600b93840b81529190920b60208201520161011a565b610136610262366004611975565b610523565b60606102a98a84848080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525061053d92505050565b9a9950505050505050505050565b6102cc6001600160a01b038516848484610721565b5050505050565b60405162461bcd60e51b815260206004820152602f60248201527f556e737570706f727465642063616c6c6261636b202d204265666f726520416760448201526e1c99595b595b9d0810dc99585d1959608a1b60648201526060906084015b60405180910390fd5b61034e6001600160a01b03831682610742565b505050565b60405162461bcd60e51b815260206004820152603160248201527f556e737570706f727465642063616c6c6261636b202d2041667465722041677260448201527019595b595b9d0815195c9b5a5b985d1959607a1b6064820152606090608401610332565b60006103ce6001600160a01b0385168484610766565b949350505050565b60405162461bcd60e51b815260206004820152603360248201527f556e737570706f727465642063616c6c6261636b202d20204265666f7265204160448201527219dc99595b595b9d0815195c9b5a5b985d1959606a1b6064820152606090608401610332565b61034e6001600160a01b038316826107e9565b60405162461bcd60e51b815260206004820152602f60248201527f556e737570706f727465642063616c6c6261636b202d204265666f726520416760448201526e1c99595b595b9d081d5c19185d1959608a1b6064820152606090608401610332565b60006103ce6001600160a01b0385168484610806565b60006104e06001600160a01b038616858585610890565b95945050505050565b6102cc6001600160a01b03851684848461092c565b6000806105166001600160a01b03871686868661094d565b9150915094509492505050565b6105376001600160a01b03841683836109f1565b50505050565b606060007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316633f6c923a846040518263ffffffff1660e01b815260040161058d9190611737565b600060405180830381865afa1580156105aa573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526105d29190810190611ac5565b60a0015190506000806000806000806000878060200190518101906105f79190611bcb565b959c50939a50919850965094509250905060ff8716610635576106266001600160a01b038c168787868e610a8b565b9850505050505050505061071b565b60001960ff881601610655576106266001600160a01b038c16878c610bb5565b60011960ff881601610675576106266001600160a01b038c16878c610cd9565b60021960ff881601610696576106266001600160a01b038c1687878d610d24565b60031960ff8816016106b8576106266001600160a01b038c168786858e610e4b565b60041960ff8816016106da576106266001600160a01b038c168588848e610ed8565b60405162461bcd60e51b81526020600482015260166024820152750d2dcecc2d8d2c840cceadcc6e8d2dedc40d2dcc8caf60531b6044820152606401610332565b92915050565b604080516000808252602082019092526104e0908690869086908690610f65565b6040805160008082526020820190925261075f9084908490611093565b9392505050565b600080610772856111b9565b6040516331e0bae760e21b81526001600160a01b0387811660048301528681166024830152919350908316915063c782eb9c90604401602060405180830381865afa1580156107c5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906104e09190611c66565b6040805160008082526020820190925261075f908490849061133a565b600080610812856111b9565b60405162735d7560e41b81526001600160a01b038881166004830152878116602483015286811660448301529193509083169150630735d75090606401602060405180830381865afa15801561086c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906104e09190611c83565b60008061089c866111b9565b60405163eccfc6a560e01b81526001600160a01b0389811660048301528881166024830152878116604483015260648201879052919350908316915063eccfc6a590608401602060405180830381865afa1580156108fe573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109229190611ca0565b9695505050505050565b604080516000808252602082019092526104e0908690869086908690611385565b600080600061095b876111b9565b604051631357247b60e21b81526001600160a01b038a8116600483015289811660248301528881166044830152600b88900b60648301529193509083169150634d5c91ec906084016040805180830381865afa1580156109bf573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109e39190611cb9565b925092505094509492505050565b6000806109fd85611412565b604051630779d36560e01b81526001600160a01b03888116600483015287811660248301528651151560448301526020870151151560648301529193509083169150630779d365906084016020604051808303816000875af1158015610a67573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906104e09190611ce8565b6060600080610a9988611412565b91509150816001600160a01b0316634329d29382836001600160a01b031663398c74e18b8b8b60006001600160401b03811115610ad857610ad8611928565b6040519080825280601f01601f191660200182016040528015610b02576020820181803683370190505b50604051602401610b169493929190611d05565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b0319168252610b61939250908990600401611d40565b6000604051808303816000875af1158015610b80573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610ba89190810190611d93565b5098975050505050505050565b6060600080610bc386611412565b91509150816001600160a01b0316634329d29382836001600160a01b031663f0b7b9158960006001600160401b03811115610c0057610c00611928565b6040519080825280601f01601f191660200182016040528015610c2a576020820181803683370190505b50604051602401610c3c929190611df6565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b0319168252610c87939250908990600401611d40565b6000604051808303816000875af1158015610ca6573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610cce9190810190611d93565b509695505050505050565b6060600080610ce786611412565b91509150816001600160a01b0316634329d29382836001600160a01b03166330925b798960006001600160401b03811115610c0057610c00611928565b6060600080610d3287611412565b91509150816001600160a01b0316634329d29382836001600160a01b031663d2c0d5428a8a60006001600160401b03811115610d7057610d70611928565b6040519080825280601f01601f191660200182016040528015610d9a576020820181803683370190505b50604051602401610dad93929190611e1a565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b0319168252610df8939250908990600401611d40565b6000604051808303816000875af1158015610e17573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610e3f9190810190611d93565b50979650505050505050565b6060600080610e5988611412565b91509150816001600160a01b0316634329d29382836001600160a01b0316636d1007a68c8b8d8c60006001600160401b03811115610e9957610e99611928565b6040519080825280601f01601f191660200182016040528015610ec3576020820181803683370190505b50604051602401610b16959493929190611e46565b6060600080610ee688611412565b91509150816001600160a01b0316634329d29382836001600160a01b0316635a6c6dbc8c8c8c8c60006001600160401b03811115610f2657610f26611928565b6040519080825280601f01601f191660200182016040528015610f50576020820181803683370190505b50604051602401610b16959493929190611e8c565b6000806000610f7388611412565b91509150816001600160a01b03166339255d5b82836001600160a01b0316636d1007a68c8c8c8c60006001600160401b03811115610fb357610fb3611928565b6040519080825280601f01601f191660200182016040528015610fdd576020820181803683370190505b50604051602401610ff2959493929190611e46565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b031916825261103d939250908990600401611eca565b6000604051808303816000875af115801561105c573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526110849190810190611f00565b50600198975050505050505050565b60008060006110a186611412565b91509150816001600160a01b03166339255d5b82836001600160a01b03166330925b798960006001600160401b038111156110de576110de611928565b6040519080825280601f01601f191660200182016040528015611108576020820181803683370190505b5060405160240161111a929190611df6565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b0319168252611165939250908990600401611eca565b6000604051808303816000875af1158015611184573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526111ac9190810190611f00565b5060019695505050505050565b7f65599bf746e17a00ea62e3610586992d88101b78eec3cf380706621fb97ea837547fc36f6c05164a669ecb6da53e218d77ae44d51cfc99f91e5a125a18de0949bee4546001600160a01b038116611309576001600160a01b03821661127e57826001600160a01b03166320bc44256040518163ffffffff1660e01b8152600401602060405180830381865afa158015611257573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061127b9190611ce8565b91505b604051635b69006f60e11b81527fdfd8ece9bfbcb8c5c540edb935641f63d67686490a1ab97f000288759f30a94660048201526001600160a01b0383169063b6d200de90602401602060405180830381865afa1580156112e2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113069190611ce8565b90505b6001600160a01b03821661131f5761131f611f34565b6001600160a01b03811661133557611335611f34565b915091565b600080600061134886611412565b91509150816001600160a01b03166339255d5b82836001600160a01b031663f0b7b9158960006001600160401b038111156110de576110de611928565b600080600061139388611412565b91509150816001600160a01b03166339255d5b82836001600160a01b0316635a6c6dbc8c8c8c8c60006001600160401b038111156113d3576113d3611928565b6040519080825280601f01601f1916602001820160405280156113fd576020820181803683370190505b50604051602401610ff2959493929190611e8c565b7f65599bf746e17a00ea62e3610586992d88101b78eec3cf380706621fb97ea837547fc36f6c05164a669ecb6da53e218d77ae44d51cfc99f91e5a125a18de0949bee4546001600160a01b038116611309576001600160a01b0382166114d757826001600160a01b03166320bc44256040518163ffffffff1660e01b8152600401602060405180830381865afa1580156114b0573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114d49190611ce8565b91505b604051635b69006f60e11b81527fdfd8ece9bfbcb8c5c540edb935641f63d67686490a1ab97f000288759f30a94660048201526001600160a01b0383169063b6d200de90602401602060405180830381865afa15801561153b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061155f9190611ce8565b9050817f65599bf746e17a00ea62e3610586992d88101b78eec3cf380706621fb97ea83755807fc36f6c05164a669ecb6da53e218d77ae44d51cfc99f91e5a125a18de0949bee4556001600160a01b03821661131f5761131f611f34565b6001600160a01b03811681146115d257600080fd5b50565b60008083601f8401126115e757600080fd5b5081356001600160401b038111156115fe57600080fd5b60208301915083602082850101111561161657600080fd5b9250929050565b600080600080600080600080600060c08a8c03121561163b57600080fd5b8935611646816115bd565b985060208a0135611656816115bd565b975060408a0135965060608a01356001600160401b038082111561167957600080fd5b6116858d838e016115d5565b909850965060808c013591508082111561169e57600080fd5b6116aa8d838e016115d5565b909650945060a08c01359150808211156116c357600080fd5b506116d08c828d016115d5565b915080935050809150509295985092959850929598565b60005b838110156117025781810151838201526020016116ea565b50506000910152565b600081518084526117238160208601602086016116e7565b601f01601f19169290920160200192915050565b60208152600061075f602083018461170b565b6000806000806080858703121561176057600080fd5b843561176b816115bd565b9350602085013561177b816115bd565b9250604085013561178b816115bd565b9396929550929360600135925050565b600080600080600080600060a0888a0312156117b657600080fd5b87356117c1816115bd565b965060208801356117d1816115bd565b95506040880135945060608801356001600160401b03808211156117f457600080fd5b6118008b838c016115d5565b909650945060808a013591508082111561181957600080fd5b506118268a828b016115d5565b989b979a50959850939692959293505050565b6000806040838503121561184c57600080fd5b8235611857816115bd565b91506020830135611867816115bd565b809150509250929050565b60008060006060848603121561188757600080fd5b8335611892816115bd565b925060208401356118a2816115bd565b915060408401356118b2816115bd565b809150509250925092565b80600b0b81146115d257600080fd5b600080600080608085870312156118e257600080fd5b84356118ed816115bd565b935060208501356118fd816115bd565b9250604085013561190d816115bd565b9150606085013561191d816118bd565b939692955090935050565b634e487b7160e01b600052604160045260246000fd5b60405161016081016001600160401b038111828210171561196157611961611928565b60405290565b80151581146115d257600080fd5b6000806000838503608081121561198b57600080fd5b8435611996816115bd565b935060208501356119a6816115bd565b92506040603f19820112156119ba57600080fd5b50604051604081018181106001600160401b03821117156119dd576119dd611928565b60409081528501356119ee81611967565b815260608501356119fe81611967565b602082015292959194509192509050565b805160ff81168114611a2057600080fd5b919050565b8051611a20816115bd565b80516001600160e01b031981168114611a2057600080fd5b600082601f830112611a5957600080fd5b81516001600160401b0380821115611a7357611a73611928565b604051601f8301601f19908116603f01168101908282118183101715611a9b57611a9b611928565b81604052838152866020858801011115611ab457600080fd5b6109228460208301602089016116e7565b600060208284031215611ad757600080fd5b81516001600160401b0380821115611aee57600080fd5b908301906101608286031215611b0357600080fd5b611b0b61193e565b611b1483611a0f565b8152611b2260208401611a0f565b602082015260408301516040820152611b3d60608401611a25565b6060820152611b4e60808401611a30565b608082015260a083015182811115611b6557600080fd5b611b7187828601611a48565b60a08301525060c083015160c082015260e083015160e0820152610100915081830151828201526101209150611ba8828401611a25565b828201526101409150611bbc828401611a25565b91810191909152949350505050565b600080600080600080600060e0888a031215611be657600080fd5b611bef88611a0f565b96506020880151611bff816115bd565b6040890151909650611c10816115bd565b6060890151909550611c21816115bd565b60808901519094506001600160801b0381168114611c3e57600080fd5b60a089015160c08a01519194509250611c56816118bd565b8091505092959891949750929550565b600060208284031215611c7857600080fd5b815161075f81611967565b600060208284031215611c9557600080fd5b815161075f816118bd565b600060208284031215611cb257600080fd5b5051919050565b60008060408385031215611ccc57600080fd5b8251611cd7816118bd565b6020840151909250611867816118bd565b600060208284031215611cfa57600080fd5b815161075f816115bd565b6001600160a01b038581168252841660208201526001600160801b03831660408201526080606082018190526000906109229083018461170b565b6001600160a01b0384168152608060208201819052600090611d649083018561170b565b8281038060408501526002825261060f60f31b602083015260408101606085015250610922604082018561170b565b60008060408385031215611da657600080fd5b82516001600160401b0380821115611dbd57600080fd5b611dc986838701611a48565b93506020850151915080821115611ddf57600080fd5b50611dec85828601611a48565b9150509250929050565b6001600160a01b03831681526040602082018190526000906103ce9083018461170b565b6001600160a01b038481168252831660208201526060604082018190526000906104e09083018461170b565b6001600160a01b0386811682528581166020830152841660408201526060810183905260a060808201819052600090611e819083018461170b565b979650505050505050565b6001600160a01b038681168252858116602083015284166040820152600b83900b606082015260a060808201819052600090611e819083018461170b565b6001600160a01b0384168152606060208201819052600090611eee9083018561170b565b8281036040840152610922818561170b565b600060208284031215611f1257600080fd5b81516001600160401b03811115611f2857600080fd5b6103ce84828501611a48565b634e487b7160e01b600052600160045260246000fdfea264697066735822122058cfd1865bbfba3181ac982b9f287e765bc8955d1e53c00e0d8b6ec556054d9064736f6c63430008130033";
const isSuperArgs = (xs) => xs.length > 1;
export class SuperTokenLibraryGDASuperAppMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_host, overrides) {
        return super.deploy(_host, overrides || {});
    }
    getDeployTransaction(_host, overrides) {
        return super.getDeployTransaction(_host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
SuperTokenLibraryGDASuperAppMock__factory.bytecode = _bytecode;
SuperTokenLibraryGDASuperAppMock__factory.abi = _abi;
//# sourceMappingURL=SuperTokenLibraryGDASuperAppMock__factory.js.map